import React from "react";
import "./LanguageSwitch.css";
import { useI18n } from "../../../i18n/i18n";

const LanguageSwitch = () => {
    const { lang, setLang } = useI18n();

    return (
        <div className="language-switch fw700 fs18">
            <div onClick={() => setLang("spa")} className={lang === "spa" ? "active" : ""}>
                SPA
            </div>
            <div className="ml4 mr4">I</div>
            <div onClick={() => setLang("eng")} className={lang === "eng" ? "active" : ""}>
                ENG
            </div>
        </div>
    );
};

export default LanguageSwitch;
